module.exports = __webpack_public_path__ + "static/media/arrow_5.f242ee4f.svg";